import * as React from "react";
import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import { CheckIcon } from "lucide-react";
import { cn } from "@/utils/tailwind";

type CheckboxProps = React.ComponentProps<typeof CheckboxPrimitive.Root> & {
  dataTest?: string;
};

function Checkbox({ className, dataTest, ...props }: CheckboxProps) {
  return (
    <CheckboxPrimitive.Root
      data-slot="checkbox"
      data-test={dataTest}
      className={cn(
        "peer border-input bg-background data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground vtac::data-[state=checked]:bg-primary data-[state=checked]:border-primary focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 vtac:aria-invalid:ring-destructive/40 aria-invalid:border-destructive size-4 shrink-0 rounded-[3px] border transition-shadow outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50",
        className,
      )}
      {...props}
    >
      <CheckboxPrimitive.Indicator
        data-slot="checkbox-indicator"
        className="grid place-content-center text-current transition-none"
      >
        <CheckIcon className="size-3.5" />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  );
}

export { Checkbox };
